import type {User, UsersApiResponse} from '../types';

export function createMockUser(props: any): User {
    return props;
}

export function createMockSessionResponse(props: any): UsersApiResponse {
    return props;
}
